import { tv } from "@/utils/tv.config";

export const iconButtonClasses = tv({
  base: ["Icon__button", "!p-0", "border-none"],
  variants: {},
});
